export function isStringValid(item) {
  return item !== null && item !== undefined && item !== '';
}